module.exports = __webpack_public_path__ + "img/ANTENNA RADIO BW.07da324.svg";